import $ from "jquery/src/jquery";
import { Base64 } from "js-base64";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CryptoJSDecrypt, CryptoJSEncrypt } from "../utils/encryption";
import {
  loginSessionAsync,
  ThirdPartyloginSessionAsync,
} from "../redux/slice/loginSlice";
import { useDispatch } from "react-redux";
import { UserToken, toastError } from "../utils/helper";
import { LoginUserFromThirdParty } from "../redux/api/loginApi";

let obj = {};
let variablesInArray = ["MobileNo", "UserToken", "url"];

export default function ThirdPartyLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const loginParams = params.get("code");

  const base64Str = Base64.decode(loginParams);

  useEffect(() => {
    convertValueFromUrlPrams();
    userLoginApi();
  }, []);

  const userLoginApi = async () => {
    dispatch(ThirdPartyloginSessionAsync(obj))
      .then((res) => {
        const originalPromiseResult = JSON.parse(CryptoJSDecrypt(res.payload));
        if (originalPromiseResult.Code === "100") {
          localStorage.setItem("LI_PROFILE", res.payload);
          navigate("/" + obj.url);
          return;
        }
        toastError("Username or password is incorrect");
      })
      .catch((err) => {
        toastError("API Error. Please try again.");
      })
      .finally();
  };

  async function convertValueFromUrlPrams() {
    await $.each(base64Str.split(/\|/), function (i, val) {
      obj[variablesInArray[i]] = val;
    });
  }
}
